import React from "react";
import PropTypes from "prop-types";
import FiberManualRecord from "@mui/icons-material/FiberManualRecord";
import { alpha } from "@mui/material/styles";
import { colors } from "../../theme/colors";

const success = colors.state.success.main;
const offline = "#7D808A";

export default function StatusDot({
    online = false,
    variant = "inline",
    animateGlow = true,
    sx: sxProp = {},
    className,
}) {
    const glow =
        animateGlow &&
        online &&
        variant === "inline" && {
            "@keyframes statusDotGlow": {
                "0%, 100%": {
                    filter: `drop-shadow(0 0 6px ${alpha(success, 0.45)}) drop-shadow(0 0 2px ${alpha(success, 0.3)})`,
                },
                "50%": {
                    filter: `drop-shadow(0 0 11px ${alpha(success, 0.65)}) drop-shadow(0 0 3px ${alpha(success, 0.4)})`,
                },
            },
            animation: "statusDotGlow 2.6s ease-in-out infinite",
        };

    const base =
        variant === "avatar"
            ? {
                  position: "absolute",
                  bottom: "0.275rem",
                  right: "-0.05rem",
                  zIndex: 3,
                  fontSize: { xs: "0.5rem", xl: "0.65rem" },
                  color: online ? success : offline,
                  backgroundColor: "rgba(28, 30, 32, 0.9)",
                  borderRadius: "50%",
                  padding: "0.1rem",
                  boxSizing: "content-box",
              }
            : {
                  display: "block",
                  fontSize: { xs: "0.8rem", xl: "1rem" },
                  color: online ? success : offline,
                  flexShrink: 0,
                  ...glow,
              };

    return (
        <FiberManualRecord
            className={className}
            sx={{
                ...base,
                ...sxProp,
            }}
            aria-hidden
        />
    );
}

StatusDot.propTypes = {
    online: PropTypes.bool,
    variant: PropTypes.oneOf(["avatar", "inline"]),
    animateGlow: PropTypes.bool,
    sx: PropTypes.object,
    className: PropTypes.string,
};
